import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout/Layout.vue';
import Login from '../views/Login';

Vue.use(Router)

export const routes = [
  {
    path: '/dashboard',
    name: '数据看板',
    component: Layout,
    icon: 'el-icon-data-line',
    redirect: "/dashboard/index",
    children: [
      {
        path: '/dashboard/index',
        name: '数据看板',
        component: () => import('@/views/Dashboard/index.vue'),
      },
    ]
  },
  {
    path: '/system',
    name: '系统管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/system/user",
    children: [
      {
        path: '/system/user',
        name: '用户管理',
        component: () => import('@/views/system/user/List.vue'),
      },
      {
        path: '/system/role',
        name: '角色管理',
        component: () => import('@/views/system/role/List.vue'),
      },
      {
        path: '/system/permission',
        name: '权限管理',
        component: () => import('@/views/system/permission/List.vue'),
      },
      {
        path: '/system/user/list',
        name: '用户列表',
        component: () => import('@/views/system/user/List.vue'),
      }
    ],

  },
  {
    path: '/property',
    name: '物业管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/property/building",
    children: [
      {
        path: '/property/building',
        name: '楼栋单元管理',
        component: () => import('@/views/property/building/List.vue'),
      },
      {
        path: '/property/house',
        name: '房间管理',
        component: () => import('@/views/property/house/List.vue'),
      },
      {
        path: '/property/park',
        name: '停车位管理',
        component: () => import('@/views/property/park/List.vue'),
      },
    ],
  },
  {
    path: '/wx',
    name: '小程序管理',
    component: Layout,
    icon: 'el-icon-setting',
    redirect: "/wx/index",
    children: [
      {
        path: '/wx/index',
        name: '小程序管理',
        component: () => import('@/views/wx/wx/List.vue'),
      },

    ],
  },
  {
    path: '/merchant',
    name: '商家管理',
    component: Layout,
    redirect: "/merchant/index",
    children: [
      {
        path: '/merchant/index',
        name: '商户管理',
        component: () => import('@/views/Merchant/merchant/list.vue'),
      },
      {
        path: '/merchant/goods/index',
        name: '商品管理',
        component: () => import('@/views/Merchant/goods/list.vue'),
      },
      {
        path: '/merchant/goods/category/index',
        name: '商品分类',
        component: () => import('@/views/Merchant/goodsCategory/list.vue'),
      },
      {
        path: '/merchant/goods/coupon/index',
        name: '优惠券管理',
        component: () => import('@/views/Merchant/coupon/list.vue'),
      },       {
        path: '/merchant/category/index',
        name: '商户分类',
        component: () => import('@/views/Merchant/merchantCategory/list.vue'),
      },
    ],
  },
  {
    path: '/points',
    name: '积分管理',
    component: Layout,
    icon: 'el-icon-star-on',
    redirect: "/points/config",
    children: [
      {
        path: '/points/config',
        name: '积分配置',
        component: () => import('@/views/Points/config/List.vue'),
      },
      {
        path: '/points/merchant',
        name: '商家积分设置',
        component: () => import('@/views/Points/merchant/List.vue'),
      },
    ],
  },
  {
    path: '/supplier',
    name: '供应商管理',
    component: Layout,
    icon: 'el-icon-truck',
    redirect: "/supplier/index",
    children: [
      {
        path: '/supplier/index',
        name: '供应商列表',
        component: () => import('@/views/Supplier/List.vue'),
      },
    ],
  },
  {
    path: '/pay',
    name: '支付配置',
    component: Layout,
    redirect: "/pay/index",
    children: [
      {
        path: '/pay/index',
        name: '支付管理',
        component: () => import('@/views/Pay/pay/list.vue'),
      },
      {
        path: '/pay/withdraw',
        name: '用户提现审核',
        component: () => import('@/views/Pay/withdraw/list.vue'),
      },
      {
        path: '/pay/merchant-withdraw',
        name: '商家提现审核',
        component: () => import('@/views/Pay/merchantWithdraw/list.vue'),
      },
      {
        path: '/pay/profit',
        name: '分账列表',
        component: () => import('@/views/Pay/profitSharing/list.vue'),
      },
      {
        path: '/merchant/withdraw',
        name: '商家提现',
        component: () => import('@/views/Pay/merchantWithdraw/Apply.vue'),
      },
    ]
  },
  {
    path: '/order',
    name: '订单管理',
    component: Layout,
    redirect: "/order/index",
    children: [
      {
        path: '/order/index',
        name: '订单管理',
        component: () => import('@/views/Order/list.vue'),
      },
    ]
  },
  {
    path: '/printer',
    name: '打印机管理',
    component: Layout,
    redirect: "/printer/index",
    children: [
      {
        path: '/printer/index',
        name: '打印机管理',
        component: () => import('@/views/Printer/printer/list.vue'),
      },
    ]
  },
  {
    path: '/goods/add',
    name: '添加商品',
    component: () => import('@/views/Merchant/goods/addGoods.vue')
  },
  {
    path: '/goods/edit',
    name: '编辑商品',
    component: () => import('@/views/Merchant/goods/editGoods.vue')
  },
  {
    path: '/user',
    component: Layout,
    name: '用户管理',
    icon: 'el-icon-user',
    redirect: '/user/list',
    children: [
      {
        path: '/user/list',
        component: () => import('@/views/User/List.vue'),
        name: '用户列表',
      },
    ],
  },
  // {
  //   path: '/product',
  //   component: Layout,
  //   name: '系统设置',
  //   icon: 'el-icon-setting',
  //   children: [
  //     {
  //       path: '/product/list',
  //       component: () => import('@/views/Product/List.vue'),
  //       name: '系统aa',
  //     }
  //   ],
  // },
  {
    path: '/',
    name: 'Login',
    component: Login
  }
]

const router = new Router({
  routes
})

export default router